import Slide from '@material-ui/core/Slide';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import React from 'react';
export const Message = ({ value, severity, handleClose, open }) => {
    return (React.createElement(Snackbar, { TransitionComponent: Slide, anchorOrigin: { vertical: 'top', horizontal: 'right' }, autoHideDuration: 6 * 1000, onClose: handleClose, open: open },
        React.createElement(MuiAlert, { "data-ph-mask": severity === 'error' || undefined, elevation: 6, onClose: handleClose, severity: severity, variant: "filled" }, value)));
};
